import { render } from "./HelpVideos.vue?vue&type=template&id=e8d8bb94&scoped=true"
import script from "./HelpVideos.vue?vue&type=script&lang=js"
export * from "./HelpVideos.vue?vue&type=script&lang=js"

import "./HelpVideos.vue?vue&type=style&index=0&id=e8d8bb94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8d8bb94"]])

export default __exports__